import React, { Component } from 'react';
import { connect } from 'react-redux';
import QRScan from './pages/QRScan';
import Login from './pages/Login';
import Routes from './constants/routes';
import Payment from './pages/Payment';
import Success from './pages/Success';
import Blank from './pages/Blank';
import { 
    // resetAllData, 
    setListenerStart,
    setListenerQRRegistered,
    setSessionExpired,
    setMerchantInfo,
    setRedirectURL,
    setQueryFailed,
    updateCurPageData,
    updateTransactionData,
    setPaymentError,
    setCurPageIsError,
    setDefaultError,
    setPaymentStatus,
    setIsSkipLogin,
    updatePaymentData,
    setIsGuest,
    setStopQueryPolling,
    setIsLoading,
    updateLoginData,
    updateTopUpData,
} from './actions';
import { 
    ListenerInterval, 
    isMobile,
    getPaymentRefNum,
    decryptData
} from './constants/appState';
import { 
    ErrorCode,
    PaymentStatus
} from './constants/statusCode';
import { appService } from './services';
// import { Mock_SampleData } from './services/mock-data';
import Error from './pages/Error';
import { AppMessages, ErrorMessages } from './constants/text';
import TopUpSuccess from './pages/TopUpSuccess';
import TopUpOptions from './pages/TopUpOptions';
import TopUpPayment from './pages/TopUpPayment';
import TransactionPin from './pages/TransactionPin';



class App extends Component {
    globalListenerTimer = null;

    constructor(props) {
        super(props);

        this.state = {
            qrValue: '',
            paymentCode: '',
            paymentMerchant: '',
            paymentAmount: '',
            paymentDescription: '',
            paymentItemList: [],
            apiToken: '',
            max2FATries: '',
            maxLoginTries: '',
            minTopUp: 1000,
            hasPrestoPayToken: false,
            allowGuestPayment: false,

            isError: false,
            errorCode: '',

            stopQueryPolling: false,
        }
    }

    componentDidMount() {
        window.addEventListener('beforeunload', (event) => {
            const { appState } = this.props;
            if ((!appState.curPage.isError && 
                !(appState.curPage.id === Routes.SUCCESS)) &&
                !appState.isVerifying &&
                !appState.isUserTriggeredLeave
            ) {
                event.returnValue = AppMessages.LeavePageConfirmation;
            }
        });

        window.addEventListener('unload', (event) => {
            console.log('Status: Unload');
            clearInterval(this.globalListenerTimer);
            setListenerStart(false);

            /* const { appState } = this.props;
            if(appState.listenerData.paymentStatus === PaymentStatus.PENDING_AUTHORISE) {
                appService.apiCancelPayment({
                    paymentRefNum: getPaymentRefNum(),
                    paymentCode: window.PrestoPayObj.paymentCode
                });
            } */
        });
  
        if(!!window.PrestoPayErrorObj) {
            // NOTE: is Error Page
            console.log('Status: window.PrestoPayErrorObj existed. Is error page.');
            
            this.setState({
                isError: true,
                errorCode: window.PrestoPayErrorObj.errorCode,
            });
            
            const { updateCurPageData } = this.props;
            updateCurPageData(Routes.ERROR);
        } else {
            if(window.PrestoPaySuccessObj) {
                console.log('Status: Presto Pay finalised...');

                // if (!!isPrestoApp) {
                //     window.location.replace(MobileResultPath + 'success');
                //     return;
                // }
                
                const { 
                    updateTransactionData, 
                    updateCurPageData,
                    updateTopUpData,
                    updateLoginData,
                    updatePaymentData,
                } = this.props;

                const successObj = window.PrestoPaySuccessObj;

                // Mall PG response, to open in mobile native if mallpg_callback_mobile true.
                if (successObj.mallpg_callback_mobile) {
                    try {
                        if (window.Authorise3DSInterface) { // is Android
                            if(successObj.paymentStatus == PaymentStatus.AUTHORISED){
	                            window.Authorise3DSInterface.authoriseMallPaymentFinalize();
							}else{
								window.Authorise3DSInterface.authoriseMallPaymentFinalize(successObj.paymentStatus, successObj.errDesc);
							}
                        } else {
                            if(window.webkit.messageHandlers) { // is IOS
                                if(successObj.paymentStatus == PaymentStatus.AUTHORISED){
	                                window.webkit.messageHandlers.authoriseMallPaymentFinalize.postMessage("");
								}else{
									window.webkit.messageHandlers.authoriseMallPaymentFinalize.postMessage(
									    JSON.stringify({
									        paymentStatus: successObj.paymentStatus,
									        errDesc: successObj.errDesc
									    })
									);
								}
                            }
                        }
                    } catch (err) {
                        console.log("Failed to open mobile native: " + err);
                    }
                }

                let merchantInfo = successObj.merchantInfo;
                let merchantInfoObj = {};        
                if(typeof merchantInfo === "string" && merchantInfo.includes('&quot;')) {
                    let merchantInfoStr = merchantInfo.replace(/&quot;/g, '\"');
                    merchantInfoObj = JSON.parse(merchantInfoStr);
                } else {
                    merchantInfoObj= successObj.merchantInfo;
                }
        
                let paymentInfo = successObj.payments;
                let paymentInfoObj = {};        
                if(typeof paymentInfo === "string" && paymentInfo.includes('&quot;')) {
                    let paymentInfoStr = paymentInfo.replace(/&quot;/g, '\"');
                    paymentInfoObj = JSON.parse(paymentInfoStr);
                } else {
                    paymentInfoObj= successObj.paymentInfo;
                }

                if (successObj.paymentType === 'TopUp') {
                    if (successObj.additionalData) {
                        const additionalData =  decryptData(successObj.additionalData, successObj.paymentRefNum);
                        window.PrestoPayObj = additionalData.prestoPayObj;
                        const loginData = additionalData.loginData;
                        const paymentData = additionalData.paymentData;
                        // Set state
                        this.setState({
                            qrValue: window.PrestoPayObj.qrValue,
                            paymentCode: window.PrestoPayObj.paymentCode,
                            paymentMerchant: window.PrestoPayObj.merchantName,
                            paymentAmount: window.PrestoPayObj.amount,
                            paymentDescription: window.PrestoPayObj.displayDesc,
                            paymentItemList: window.PrestoPayObj.itemList,
                            apiToken: window.PrestoPayObj.apiToken,
                            max2FATries: window.PrestoPayObj.max2FATries,
                            maxLoginTries: window.PrestoPayObj.maxLoginTries,
                            minTopUp: window.PrestoPayObj.minTopUp,
                            hasPrestoPayToken: (!!window.PrestoPayObj.apiToken && 
                                                window.PrestoPayObj.apiToken !== ''),
                            allowGuestPayment: window.PrestoPayObj.allowGuestPayment
                        });
                        updateLoginData(loginData);
                        updatePaymentData(paymentData);
                        // do normal handling
                        this.doInitQuery(paymentData.paymentRefNum);
                    }

                    updateTopUpData({
                        paymentRefNum: successObj.paymentRefNum,
                        redirectUrl: successObj.redirectUrl,
                        amount: successObj.amount,
                        displayDesc: successObj.displayDesc,
                        payments: paymentInfoObj,
                        authorisedDate: successObj.authorisedDate,
                        merchantInfo: merchantInfoObj,
                        cardDisplayName: successObj.cardDisplayName || '',
                        paymentStatus: successObj.paymentStatus
                    });
                    updateCurPageData(Routes.TOPUP_SUCCESS);
                } else {
                    updateTransactionData({
                        paymentRefNum: successObj.paymentRefNum,
                        redirectUrl: successObj.redirectUrl,
                        amount: successObj.amount,
                        displayDesc: successObj.displayDesc,
                        payments: paymentInfoObj,
                        authorisedDate: successObj.authorisedDate,
                        merchantInfo: merchantInfoObj,
                        cardDisplayName: successObj.cardDisplayName || '',
                        paymentStatus: successObj.paymentStatus,
                        errDesc: successObj.errDesc
                    });
                    updateCurPageData(Routes.SUCCESS);
                }

            } else {
                if(!window.PrestoPayObj) {
                    // NOTE: is Page without data
                    console.log('Status: window.PrestoPayObj is undefined.');
        
                    const { 
                        setQueryFailed,
                        updateCurPageData 
                    } = this.props;
                    
                    setQueryFailed(true);
                    updateCurPageData(Routes.ERROR);
                } else {
                    this.setState({
                        qrValue: window.PrestoPayObj.qrValue,
                        paymentCode: window.PrestoPayObj.paymentCode,
                        paymentMerchant: window.PrestoPayObj.merchantName,
                        paymentAmount: window.PrestoPayObj.amount,
                        paymentDescription: window.PrestoPayObj.displayDesc,
                        paymentItemList: window.PrestoPayObj.itemList,
                        apiToken: window.PrestoPayObj.apiToken,
                        max2FATries: window.PrestoPayObj.max2FATries,
                        maxLoginTries: window.PrestoPayObj.maxLoginTries,
                        minTopUp: window.PrestoPayObj.minTopUp,
                        hasPrestoPayToken: (!!window.PrestoPayObj.apiToken && 
                                            window.PrestoPayObj.apiToken !== ''),
                        allowGuestPayment: window.PrestoPayObj.allowGuestPayment
                    });
            
                    // NOTE: let's begin
                    console.log('Status: Presto Pay connecting...');

                    if (window.PrestoPayObj.authCode !== null && window.PrestoPayObj.authCode.length > 0) {
                        // automatically do login
                        this.doAutoLogin();
                    } else {
                        // do normal handling
                        this.doInitQuery();
                    }
                }    
            }
        }
    };

    doInitQuery = (paymentRefNum) => {
        const params = {
            paymentRefNum: paymentRefNum || getPaymentRefNum(),
            paymentCode: window.PrestoPayObj.paymentCode,
            onSuccess: this.onSubmitSuccessHandler,
            onError: this.onSubmitFailedHandler
        };

        // NOTE: Call query straight away, and also start timer
        this.queryState(params);
        this.globalListenerTimer = setInterval(() => {
            this.queryState(params);
        }, ListenerInterval);
    };

    doAutoLogin = () => {
        const { setIsLoading } = this.props;

        setIsLoading(true);

        console.log("Status: Performing auto-login...");
        appService.apiLogin({
            paymentCode: window.PrestoPayObj.paymentCode,
            authCode: window.PrestoPayObj.authCode,
            onSuccess: this.onLoginSuccessHandler,
            onError: this.onLoginFailedHandler
        });
    };

    onLoginSuccessHandler = (resp) => {
        const { setIsLoading, updatePaymentData, setIsGuest, updateCurPageData } = this.props;

        setIsLoading(false);

        if(!!resp.success) {
            console.log("Status: Auto-login success");
            updatePaymentData(resp.data);
            setIsGuest(false);
            if (resp.data.requireOtp) {
                updateCurPageData(Routes.TXN_PIN);
            } else {
                updateCurPageData(Routes.PAYMENT);
            }
        }
        this.doInitQuery();
    };

    onLoginFailedHandler = (data) => {
        const { setIsLoading } = this.props;
        setIsLoading(false);
        this.doInitQuery();
    };

    componentDidUpdate(prevProps) {
        const { appState } = this.props;
        if(prevProps.appState.stopQueryPolling !== appState.stopQueryPolling) {
            if(!!appState.stopQueryPolling) {
                clearInterval(this.globalListenerTimer);
            } else {
                // NOTE: let's begin
                console.log('Status: Presto Pay reconnecting...');
                const params = {
                    paymentRefNum: getPaymentRefNum(),
                    paymentCode: window.PrestoPayObj.paymentCode,
                    onSuccess: this.onSubmitSuccessHandler,
                    onError: this.onSubmitFailedHandler,
                };

                this.globalListenerTimer = setInterval(() => {
                    this.queryState(params)
                }, ListenerInterval);
            }
        }
    }

    componentWillUnmount() {
        // NOTE: reset everything
        clearInterval(this.globalListenerTimer);
        setListenerStart(false);
        setListenerQRRegistered(false);
        setSessionExpired(false);
    };
    
    onSubmitSuccessHandler = (resp) => {
        const {
            appState,
            setListenerStart,
            setListenerQRRegistered,
            setSessionExpired,
            setPaymentError,
            setPaymentStatus,
            setMerchantInfo,
            setRedirectURL,
            setIsSkipLogin
        } = this.props;
        const {
            allowGuestPayment
        } = this.state;

        if(!!resp.success) {
            if (!appState.listenerData.started) {
                setListenerStart(true);
                // setSessionExpired(false);
                setMerchantInfo(resp.data.merchantInfo.name);
            }

            if (resp.data.redirectUrl !== appState.listenerData.redirectUrl) {
                setRedirectURL(resp.data.redirectUrl);
            }

            if (resp.data.paymentStatus !== appState.listenerData.paymentStatus) {
                setPaymentStatus(resp.data.paymentStatus);
            }
                        
            if(resp.data.qrRegistered) {
                // NOTE: proceed via mobile app
                setListenerQRRegistered(true);
            } else {
                if(resp.data.paymentStatus !== PaymentStatus.AUTHORISED) {
                    // NOTE: Still havent logged in, but if already registered will redirect back to merchant
                    if(appState.curPage.id === Routes.QRSCANPAY || appState.curPage.id === Routes.LOGINPAY) {
                        if(!appState.isGuest && !!resp.data.registered) {
                            // NOTE: if not via mobile app, and detected double login
                            console.log("Status: Detected double login");
                            this.onUserRegisteredHandler();
                            return;
                        }
                    }
                }
            }

            if(resp.data.paymentStatus === PaymentStatus.CANCELLED ||
                resp.data.paymentStatus === PaymentStatus.EXPIRED ||
                resp.data.paymentStatus === PaymentStatus.FAILED            
            ) {
                setPaymentError({
                    isError: true,
                    errorType: resp.data.paymentStatus
                });
            }
            if(resp.data.sessionExpired) {
                // NOTE: session ended, but it is actually handled in the else statement below
                clearInterval(this.globalListenerTimer);
                setSessionExpired(true);
            }
            if(resp.data.finalised) { 
                // NOTE: transaction done, reset everything
                const { 
                    updateCurPageData, 
                    updateTransactionData 
                } = this.props;
                if(resp.data.paymentStatus === PaymentStatus.AUTHORISED) {
                    updateTransactionData(resp.data);
                    updateCurPageData(Routes.SUCCESS);
                }
                clearInterval(this.globalListenerTimer);
                setListenerStart(false);
                setListenerQRRegistered(false);
                setSessionExpired(false);
            }
            if (!resp.data.registered && allowGuestPayment && appState.isSkipLogin) {
                //Only skip login once
                setIsSkipLogin(false);
                this.onSubmitGuestHandler();
            }
        } else {
            // NOTE: call is successful, but transaction is not
            if(+resp.errorCode === ErrorCode.SESSION_TIMEOUT) {
                // NOTE: session ended
                clearInterval(this.globalListenerTimer);
                setSessionExpired(true);
            }
        } 
    };

    onSubmitFailedHandler = (data) => {
        const { 
            setQueryFailed, 
            setSessionExpired 
        } = this.props;

        clearInterval(this.globalListenerTimer);
        if(+data.errorCode === ErrorCode.SESSION_TIMEOUT) {
            // NOTE: session ended
            setSessionExpired(true);
        } else {
            setQueryFailed(true);
        }
    };

    onSubmitGuestHandler = (e) => {
        if (e !== undefined) {
            e.preventDefault();
        }

        const { setStopQueryPolling, setIsLoading } = this.props;
        const { paymentCode } = this.state;
        setIsLoading(true);
        setStopQueryPolling(true);

        appService.apiLoginAsGuest({
            paymentCode: paymentCode,
            onSuccess: this.onSubmitGuestSuccessHandler,
            onError: this.onSubmitGuestFailedHandler,
        });
    };

    onSubmitGuestSuccessHandler = (resp) => {
        const { setStopQueryPolling, setIsLoading } = this.props;
        setIsLoading(false);
        setStopQueryPolling(false);
        if(!!resp.success) {
            const {
                updatePaymentData,
                setIsGuest,
                updateCurPageData
            } = this.props;

            updatePaymentData(resp.data);
            setIsGuest(true);
            updateCurPageData(Routes.PAYMENT);
        } else {
            // NOTE: not sure what happen, so just redirect to error page
            const { setDefaultError } = this.props;
            setDefaultError(true);
        }
    };

    onSubmitGuestFailedHandler = (data) => {
        const {
            setStopQueryPolling,
            setIsLoading,
            setDefaultError
        } = this.props;

        setIsLoading(false);
        setStopQueryPolling(false);
        setDefaultError(true);
    };

    onUserRegisteredHandler = () => {
        const {
            // appState,
            setListenerStart,
            setListenerQRRegistered,
            setSessionExpired,
            setCurPageIsError,
            setDefaultError,
            setStopQueryPolling
        } = this.props;

        clearInterval(this.globalListenerTimer);
        setStopQueryPolling(true);
        setListenerStart(false);
        setListenerQRRegistered(false);
        setSessionExpired(false);
        setCurPageIsError(true);
        setDefaultError(true, {
            title: ErrorMessages.DuplicatedLogin.title,
            message: ErrorMessages.DuplicatedLogin.message,
        });
    };
    
    queryState = (params) => {
        appService.apiQuery(params);
    };

    render() {
        const { appState } = this.props;
        const { 
            qrValue,
            paymentCode,
            paymentMerchant,
            paymentAmount,
            paymentDescription,
            paymentItemList,
            apiToken,
            max2FATries,
            maxLoginTries,
            hasPrestoPayToken,
            allowGuestPayment,
            isError,
            errorCode,
        } = this.state;

        const transactionState = {
            qrValue,
            paymentCode,
            paymentMerchant,
            paymentAmount,
            paymentDescription,
            paymentItemList,
            apiToken,
            max2FATries,
            maxLoginTries,
            allowGuestPayment
        }

        return ( !isError || hasPrestoPayToken ? (
            <React.Fragment>
                {(!appState.curPage.id) && (
                    (window.PrestoPayObj && (window.PrestoPayObj.allowGuestPayment || (window.PrestoPayObj.authCode))) ? <Blank /> :
                        !isMobile()
                            ? <QRScan transactionState={transactionState} />
                            : <Login transactionState={transactionState} />
                )}
                { (appState.curPage.id === Routes.QRSCANPAY) && <QRScan transactionState={transactionState} /> }
                { (appState.curPage.id === Routes.LOGINPAY) && <Login transactionState={transactionState} /> }
                { (appState.curPage.id === Routes.PAYMENT) && <Payment transactionState={transactionState} /> }
                { (appState.curPage.id === Routes.SUCCESS) && <Success transactionState={transactionState} /> }
                { (appState.curPage.id === Routes.TOPUP_OPTIONS) && <TopUpOptions transactionState={transactionState} /> }
                { (appState.curPage.id === Routes.TOPUP_PAYMENT) && <TopUpPayment transactionState={transactionState} /> }
                { (appState.curPage.id === Routes.TOPUP_SUCCESS) && <TopUpSuccess transactionState={transactionState} /> }
                { (appState.curPage.id === Routes.TXN_PIN) && <TransactionPin transactionState={transactionState} /> }
                { (appState.curPage.id === Routes.ERROR) && <Error errorCode={''} /> }
            </React.Fragment>
        ) : (
            <React.Fragment>
                { (appState.curPage.id === Routes.ERROR) && <Error errorCode={errorCode} /> }
            </React.Fragment>
        ));
    }
}

const mapStateToProps = (state) => {
    return ({
        appState: state.app.appState,
    })
};

const mapDispatchToProps = (dispatch) => ({
    dispatch,
    setListenerStart: (data) => dispatch(setListenerStart(data)),
    setListenerQRRegistered: (data) => dispatch(setListenerQRRegistered(data)),
    setSessionExpired: (data) => dispatch(setSessionExpired(data)),
    setMerchantInfo: (data) => dispatch(setMerchantInfo(data)),
    setRedirectURL: (data) => dispatch(setRedirectURL(data)),
    setPaymentError: (data) => dispatch(setPaymentError(data)),
    setPaymentStatus: (data) => dispatch(setPaymentStatus(data)),
    setQueryFailed: (data) => dispatch(setQueryFailed(data)),
    setCurPageIsError: (data) => dispatch(setCurPageIsError(data)),
    setDefaultError: (data, errorDetails) => dispatch(setDefaultError(data, errorDetails)),
    setIsSkipLogin: (data) => dispatch(setIsSkipLogin(data)),
    setIsGuest: (data) => dispatch(setIsGuest(data)),
    updateTransactionData: (data) => dispatch(updateTransactionData(data)),
    updateCurPageData: (data) => dispatch(updateCurPageData(data)),
    updatePaymentData: (data) => dispatch(updatePaymentData(data)),
    setStopQueryPolling: (data) => dispatch(setStopQueryPolling(data)),
    setIsLoading: (data) => dispatch(setIsLoading(data)),
    updateLoginData: (data) => dispatch(updateLoginData(data)),
    updateTopUpData: (data) => dispatch(updateTopUpData(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(App);
